import React, { useState } from "react";
import { useParams } from "react-router-dom";
import API from "../../api/axiosInstance";
import axios from "axios";

const ResetPassword: React.FC = () => {
    const { token } = useParams();
    const [newPassword, setNewPassword] = useState("");
    const [message, setMessage] = useState("");

    const handleReset = async () => {
        try {
            await API.post("/auth/reset-password", { token, newPassword });
            setMessage("Password reset successfully. You can now log in.");
        } catch (error: unknown) {
            if (axios.isAxiosError(error)) {
                setMessage("Error: " + (error.response?.data?.message || "Failed to reset password."));
            } else {
                setMessage("An unexpected error occurred resetting password.");
            }
        }
    };

    return (
        <div>
            <h3>Reset Your Password</h3>
            <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="New Password" />
            <button onClick={handleReset}>Reset Password</button>
            {message && <p>{message}</p>}
        </div>
    );
};

export default ResetPassword;
